import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[mcListItemLine]'
})
export class ListItemLineDirective {
  constructor(public templateRef: TemplateRef<any>) { }
}
